module.exports = __webpack_public_path__ + "img/substation-img_6.0e60231d.png";